import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface IPasswordConfirmField {
	changePasswordConfirm: (value: string) => void;
}

const PasswordConfirmField: React.FC<IPasswordConfirmField> = ({ changePasswordConfirm }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('confirmPassword') },
			({ getFieldValue }) => ({
				validator(_, value) {
					if (!value || getFieldValue('password') === value) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('passwordsShouldBeTheSame')));
				},
			}),
		],
		[t],
	);

	return (
		<FormInput
			testId="PasswordConfirmField"
			name="passwordConfirm"
			label="confirmPasswordLabel"
			type="password"
			onChange={changePasswordConfirm}
			validationRules={validationRules}
			iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
			allowClear={false}
			dependencies={['password']}
		/>
	);
};

export default React.memo(PasswordConfirmField);
